import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Flex,
  Icon,
  Image,
  LinkBox,
  LinkOverlay,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { BiLink } from "react-icons/bi";
import SocialAccountPropType from "../../../_types//SocialAccount";
import PostPropType from "../../../_types/Post";
import { getUrl } from "../../../_utils/url";
import { formatPostMessage } from "../../../_utils/postMessageFormatter";
import SocialAccountAvatar from "../SocialAccountAvatar/SocialAccountAvatar";
import {
  getFixedPhotosVideosOrder,
  getMediaFileMeta,
} from "../PostEditor/helpers";

const SocialPostCardTwitter = ({
  account,
  post,
  time,
  timeFull,
  ...props
}) => {
  const [isSmallScraperImage, setIsSmalScraperImage] = useState(true);
  const type = account?.social_type;

  const initScraperMediaMeta = useCallback(async () => {
    if (post?.scraper?.image) {
      const meta = await getMediaFileMeta("image", post?.scraper?.image);
      const isLarge = meta.width >= 400 && meta.height >= 400;

      setIsSmalScraperImage(!isLarge);
    } else {
      setIsSmalScraperImage(true);
    }
  }, [post?.scraper?.image, setIsSmalScraperImage]);

  useEffect(() => {
    initScraperMediaMeta();
  }, [post?.scraper?.image]);

  if (!account || !post || !type) {
    return null;
  }

  const renderHeader = ({ time }) => (
    <Box>
      <Flex sx={{ alignItems: "center", position: "relative" }}>
        <Box
          sx={{
            position: "absolute",
            top: "0",
            left: "-59px",
            width: "49px",
            height: "49px",
            lineHeight: "49px",
          }}
        >
          <SocialAccountAvatar
            sx={{
              position: "relative",
              width: "full",
              height: "full",
              fontSize: "16px",
              borderRadius: "full",
              _after: {
                position: "absolute",
                inset: "0",
                borderRadius: "full",
                border: "1px solid rgba(0,0,0,.04)",
                content: '""',
              },
            }}
            name={account.name}
            src={account.image}
            socialType={account.social_type}
          />
        </Box>
        <Flex>
          <Flex
            sx={{
              fontSize: "15px",
              fontWeight: "400",
              lineHeight: "1.3125",
              color: "#5b7083",
            }}
          >
            <Text sx={{ fontWeight: "700", color: "#0f1419" }}>
              {account.name}
            </Text>
            {account.nickname && (
              <Text d={["none", "inline"]} ml="5px">
                @{account.nickname}
              </Text>
            )}
          </Flex>
          <Flex
            sx={{
              fontSize: "15px",
              fontWeight: "400",
              lineHeight: "1.3125",
              color: "#5b7083",
            }}
            _before={{
              fontSize: "0.6em",
              alignSelf: "center",
              margin: "0 5px",
              content: '"\\2022"',
            }}
          >
            <Tooltip hasArrow label={timeFull} placement="top">
              <Box>{time}</Box>
            </Tooltip>
          </Flex>
        </Flex>
        {/* <Box sx={{ marginLeft: "auto" }}>
          <Box>
            {postMenu ? (
              postMenu
            ) : (
              <Box
                sx={{ fontSize: "16px", color: "#606770" }}
                _before={{ content: '"\\25E6\\25E6\\25E6"' }}
              />
            )}
          </Box>
        </Box> */}
      </Flex>
    </Box>
  );

  const renderFooter = () => {
    const actionStyles = {
      alignItems: "center",
      justifyContent: "center",
    };
    const actionIconStyles = {
      fontSize: "15px",
      fontWeight: "400",
      lineHeight: "1.3125",
      color: "#5b7083",
      boxSizing: "content-box",
      width: "1.25em",
      height: "1.25em",
      fill: "currentColor",
    };

    return (
      <Box sx={{ marginTop: "10px" }}>
        <Box>
          <Flex
            sx={{
              alignItems: "center",
              justifyContent: "space-between",
              maxWidth: "425px",
            }}
          >
            <Flex sx={actionStyles}>
              <Icon sx={actionIconStyles} viewBox="0 0 24 24">
                <path
                  // eslint-disable-next-line max-len
                  d="M14.046 2.242l-4.148-.01h-.002c-4.374 0-7.8 3.427-7.8 7.802 0 4.098 3.186 7.206 7.465 7.37v3.828c0 .108.044.286.12.403.142.225.384.347.632.347.138 0 .277-.038.402-.118.264-.168 6.473-4.14 8.088-5.506 1.902-1.61 3.04-3.97 3.043-6.312v-.017c-.006-4.367-3.43-7.787-7.8-7.788zm3.787 12.972c-1.134.96-4.862 3.405-6.772 4.643V16.67c0-.414-.335-.75-.75-.75h-.396c-3.66 0-6.318-2.476-6.318-5.886 0-3.534 2.768-6.302 6.3-6.302l4.147.01h.002c3.532 0 6.3 2.766 6.302 6.296-.003 1.91-.942 3.844-2.514 5.176z"
                />
              </Icon>
            </Flex>
            <Flex sx={actionStyles}>
              <Icon sx={actionIconStyles} viewBox="0 0 24 24">
                <path
                  // eslint-disable-next-line max-len
                  d="M23.77 15.67c-.292-.293-.767-.293-1.06 0l-2.22 2.22V7.65c0-2.068-1.683-3.75-3.75-3.75h-5.85c-.414 0-.75.336-.75.75s.336.75.75.75h5.85c1.24 0 2.25 1.01 2.25 2.25v10.24l-2.22-2.22c-.293-.293-.768-.293-1.06 0s-.294.768 0 1.06l3.5 3.5c.145.147.337.22.53.22s.383-.072.53-.22l3.5-3.5c.294-.292.294-.767 0-1.06zm-10.66 3.28H7.26c-1.24 0-2.25-1.01-2.25-2.25V6.46l2.22 2.22c.148.147.34.22.532.22s.384-.073.53-.22c.293-.293.293-.768 0-1.06l-3.5-3.5c-.293-.294-.768-.294-1.06 0l-3.5 3.5c-.294.292-.294.767 0 1.06s.767.293 1.06 0l2.22-2.22V16.7c0 2.068 1.683 3.75 3.75 3.75h5.85c.414 0 .75-.336.75-.75s-.337-.75-.75-.75z"
                />
              </Icon>
            </Flex>
            <Flex sx={actionStyles}>
              <Icon sx={actionIconStyles} viewBox="0 0 24 24">
                <path
                  // eslint-disable-next-line max-len
                  d="M12 21.638h-.014C9.403 21.59 1.95 14.856 1.95 8.478c0-3.064 2.525-5.754 5.403-5.754 2.29 0 3.83 1.58 4.646 2.73.814-1.148 2.354-2.73 4.645-2.73 2.88 0 5.404 2.69 5.404 5.755 0 6.376-7.454 13.11-10.037 13.157H12zM7.354 4.225c-2.08 0-3.903 1.988-3.903 4.255 0 5.74 7.034 11.596 8.55 11.658 1.518-.062 8.55-5.917 8.55-11.658 0-2.267-1.823-4.255-3.903-4.255-2.528 0-3.94 2.936-3.952 2.965-.23.562-1.156.562-1.387 0-.014-.03-1.425-2.965-3.954-2.965z"
                />
              </Icon>
            </Flex>
            <Flex sx={actionStyles}>
              <Icon sx={actionIconStyles} viewBox="0 0 24 24">
                <g>
                  <path
                    // eslint-disable-next-line max-len
                    d="M17.53 7.47l-5-5c-.293-.293-.768-.293-1.06 0l-5 5c-.294.293-.294.768 0 1.06s.767.294 1.06 0l3.72-3.72V15c0 .414.336.75.75.75s.75-.336.75-.75V4.81l3.72 3.72c.146.147.338.22.53.22s.384-.072.53-.22c.293-.293.293-.767 0-1.06z"
                  />
                  <path
                    // eslint-disable-next-line max-len
                    d="M19.708 21.944H4.292C3.028 21.944 2 20.916 2 19.652V14c0-.414.336-.75.75-.75s.75.336.75.75v5.652c0 .437.355.792.792.792h15.416c.437 0 .792-.355.792-.792V14c0-.414.336-.75.75-.75s.75.336.75.75v5.652c0 1.264-1.028 2.292-2.292 2.292z"
                  />
                </g>
              </Icon>
            </Flex>
          </Flex>
        </Box>
      </Box>
    );
  };

  const renderMessage = ({ message }) => (
    <Box>
      <Box
        sx={{
          fontSize: "15px",
          fontWeight: "400",
          lineHeight: "1.3125",
          color: "#0f1419",
          "& a": {
            color: "#1b95e0",
          },
        }}
        dangerouslySetInnerHTML={{
          __html: formatPostMessage(message),
        }}
      />
    </Box>
  );

  const renderMedia = () => {
    const maxItems = 4;
    const mediaItems = getFixedPhotosVideosOrder(
      post?.photos,
      post?.videos
    ).items;
    const mediaItemsSliced = mediaItems.slice(0, maxItems);

    const mediaItemPositions = {
      1: {
        1: "0 0 0 0",
      },
      2: {
        1: "0 calc(50% + 1.01px) 0 0",
        2: "0 0 0 calc(50% + 1.01px)",
      },
      3: {
        1: "0 calc(50% + 1.01px) 0 0",
        2: "0 0 calc(50% + 1.01px) calc(50% + 1.01px)",
        3: "calc(50% + 1.01px) 0 0 calc(50% + 1.01px)",
      },
      4: {
        1: "0 calc(50% + 1.01px) calc(50% + 1.01px) 0",
        2: "0 0 calc(50% + 1.01px) calc(50% + 1.01px)",
        3: "calc(50% + 1.01px) calc(50% + 1.01px) 0 0",
        4: "calc(50% + 1.01px) 0 0 calc(50% + 1.01px)",
      },
    };

    const mediaItemStyles = {
      display: "inline-block",
      position: "absolute",
      inset: "0",
      width: "100%",
      height: "100%",
      verticalAlign: "top",
      objectFit: "cover",
    };

    return (
      <Box>
        <Box
          sx={{
            position: "relative",
            marginTop: "10px",
            border: "1px solid #c4cfd6",
            borderRadius: "16px",
            overflow: "hidden",
            paddingTop: "56.25%",
            height: "0",
          }}
        >
          {mediaItemsSliced.map((item, index) => (
            <Box
              key={item.data.url}
              sx={{
                position: "absolute",
              }}
              style={{
                inset:
                  mediaItemPositions?.[mediaItemsSliced.length]?.[index + 1] ||
                  null,
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  padding: "0",
                  width: "full",
                  height: "full",
                  overflow: "hidden",
                  background: "#dddddd",
                }}
              >
                {item.field === "videos" ? (
                  <Box
                    as="video"
                    sx={mediaItemStyles}
                    src={item.data.url}
                    controls
                    preload="metadata"
                  />
                ) : (
                  <Image sx={mediaItemStyles} src={item.data.url} />
                )}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    );
  };

  const renderLink = () => {
    const url = getUrl(post?.scraper?.link || "");
    const hasScraperImage = !!post?.scraper?.image;

    return (
      <Box>
        <LinkBox
          sx={{
            position: "relative",
            marginTop: "10px",
            border: "1px solid #c4cfd6",
            borderRadius: "16px",
            overflow: "hidden",
            display: isSmallScraperImage ? "flex" : null,
            alignItems: isSmallScraperImage ? "stretch" : null,
            borderTopColor: isSmallScraperImage ? "#ced0d4" : null,
            borderBottomColor: isSmallScraperImage ? "#ced0d4" : null,
          }}
        >
          <Box
            sx={{
              background: "#f7f9fa",
              width: isSmallScraperImage ? "124px" : null,
            }}
          >
            <Box
              sx={{
                position: "relative",
                paddingTop: isSmallScraperImage ? "100%" : "52.2%",
                height: "0",
                overflow: "hidden",
              }}
            >
              {hasScraperImage ? (
                <Image
                  sx={{
                    position: "absolute",
                    inset: "0",
                    width: "full",
                    height: "full",
                    objectFit: "cover",
                  }}
                  src={post.scraper.image}
                />
              ) : null}
            </Box>
          </Box>
          <LinkOverlay
            sx={{
              display: isSmallScraperImage ? "flex" : "block",
              alignItems: isSmallScraperImage ? "center" : null,
              width: isSmallScraperImage ? "calc(100% - 124px)" : "100%",
              borderTop: isSmallScraperImage ? null : "1px solid #c4cfd6",
              borderLeft: isSmallScraperImage ? "1px solid #c4cfd6" : null,
              padding: "10px",
            }}
            href={post.scraper.link}
            isExternal
          >
            <Box sx={{ width: "full" }}>
              {post.scraper.title ? (
                <Text
                  sx={{
                    fontSize: "15px",
                    fontWeight: "400",
                    lineHeight: "1.3125",
                    color: "#0f1419",
                  }}
                  noOfLines={1}
                >
                  {post.scraper.title}
                </Text>
              ) : null}
              {post.scraper.description ? (
                <Text
                  sx={{
                    fontSize: "15px",
                    fontWeight: "400",
                    lineHeight: "1.3125",
                    marginTop: "2px",
                    color: "#5b7083",
                  }}
                  noOfLines={2}
                >
                  {post.scraper.description}
                </Text>
              ) : null}
              <Text
                sx={{
                  fontSize: "15px",
                  fontWeight: "400",
                  lineHeight: "1.3125",
                  marginTop: "2px",
                  color: "#5b7083",
                }}
                noOfLines={1}
              >
                <Icon
                  as={BiLink}
                  sx={{
                    display: "inline-block",
                    width: "1.25em",
                    height: "1.25em",
                    fontSize: "13px",
                    verticalAlign: "middle",
                    marginRight: "2px",
                  }}
                />
                {url?.hostname || ""}
              </Text>
            </Box>
          </LinkOverlay>
        </LinkBox>
      </Box>
    );
  };

  const showMedia = !!post?.videos?.length || !!post?.photos?.length;
  const showLink = !showMedia && post?.scraper?.link;
  const comments = (post?.comments || []).map((item, index) => ({
    ...item,
    id: index,
  }));

  return (
    <Box
      sx={{
        background: "white",
        fontFamily:
          'apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        border: "1px solid #ebeef0",
        maxWidth: "598px",
      }}
      {...props}
    >
      <Box sx={{ padding: "10px 15px" }}>
        <Box sx={{ padding: "0 0 0 59px", minHeight: "49px" }}>
          {renderHeader({ time })}
          <Box>
            <Box>
              {renderMessage({ message: post.message })}
              {showMedia ? renderMedia() : null}
              {showLink ? renderLink() : null}
            </Box>
          </Box>
          {renderFooter()}
        </Box>
      </Box>
      {comments.map((item, itemIndex) => (
        <Box
          key={item.id}
          sx={{
            padding: "10px 15px",
            borderTop: itemIndex ? null : "1px solid #ebeef0",
          }}
        >
          <Box sx={{ padding: "0 0 0 59px", minHeight: "49px" }}>
            {renderHeader({ time: `+${item.delay || 0} min` })}
            <Box>
              <Box>{renderMessage({ message: item.message })}</Box>
            </Box>
            {renderFooter()}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

SocialPostCardTwitter.propTypes = {
  account: SocialAccountPropType.isRequired,
  post: PostPropType.isRequired,
  time: PropTypes.string.isRequired,
  timeFull: PropTypes.string.isRequired,
};

export default SocialPostCardTwitter;
